module.exports = __webpack_public_path__ + "static/6-IMG-4676-c741a8ccd1f65e03bf15c67eefceb8f3.jpg";